import styled from 'styled-components'

const Loading = styled.div`
  flex: 1 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 64px;
  opacity: 0.7;

  ${({ overlay, container }) => overlay ? `
    position: ${container ? 'absolute' : 'fixed'};
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.8);
    z-index: 888888;
  ` : ''}

  & > img {
    animation: loading-animation 1s linear infinite;
    width: 80px;
    height: 80px;
  }

  & > div {
    display: inline-block;
    width: 80px;
    height: 80px;
  }

  & > div:after {
    content: " ";
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid #000;
    border-color: #000 transparent #000 transparent;
    animation: loading-animation 1.2s linear infinite;
  }

  ${({ loadingAniation }) => `${loadingAniation}`}
`
export default {
  Loading,
}
